// extracted by mini-css-extract-plugin
export default {"root":"VideoFormatFormMode_root__huaml"};